type Props = {
  height: number;
  width: number;
};

export const EnabledFeatureIcon = ({ height, width }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 8 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.00292 8.5C3.45236 8.5 2.93403 8.39583 2.44792 8.1875C1.96181 7.97917 1.53646 7.69271 1.17188 7.32812C0.807292 6.96354 0.520833 6.53833 0.3125 6.0525C0.104167 5.56667 0 5.04757 0 4.49521C0 3.94285 0.104167 3.42535 0.3125 2.94271C0.520833 2.46007 0.807292 2.03646 1.17188 1.67188C1.53646 1.30729 1.96167 1.02083 2.4475 0.8125C2.93333 0.604167 3.45243 0.5 4.00479 0.5C4.55715 0.5 5.07465 0.604167 5.55729 0.8125C6.03993 1.02083 6.46354 1.30729 6.82812 1.67188C7.19271 2.03646 7.47917 2.46083 7.6875 2.945C7.89583 3.42924 8 3.9466 8 4.49708C8 5.04764 7.89583 5.56597 7.6875 6.05208C7.47917 6.53819 7.19271 6.96354 6.82812 7.32812C6.46354 7.69271 6.03917 7.97917 5.555 8.1875C5.07076 8.39583 4.5534 8.5 4.00292 8.5ZM4 7.75C4.90278 7.75 5.67014 7.43403 6.30208 6.80208C6.93403 6.17014 7.25 5.40278 7.25 4.5C7.25 3.59722 6.93403 2.82986 6.30208 2.19792C5.67014 1.56597 4.90278 1.25 4 1.25C3.09722 1.25 2.32986 1.56597 1.69792 2.19792C1.06597 2.82986 0.75 3.59722 0.75 4.5C0.75 5.40278 1.06597 6.17014 1.69792 6.80208C2.32986 7.43403 3.09722 7.75 4 7.75Z"
        fill="#030303"
      />
    </svg>
  );
};
